import { Router } from '@angular/router';
import { map, switchMap } from 'rxjs/operators';
import { StorageService } from '../_services/storage.service';
import { MetaService } from '@ngx-meta/core';
import { ApiService } from '../_services/api.service';
import { environment } from '../../../environments/environment';
import { LocalizeRouterService } from 'localize-router';
// tslint:disable: variable-name
var SearchSchede = /** @class */ (function () {
    function SearchSchede() {
        this.orderBy = 'prezzo';
        this.orderType = 'asc';
        this.numRecordIniziale = 1;
        this.numRecordDaEstrarre = environment.schedePerPagina;
        this.soloMappa = false;
    }
    return SearchSchede;
}());
export { SearchSchede };
var CardListResolver = /** @class */ (function () {
    function CardListResolver(storage, meta, apiService, router, localize) {
        this.storage = storage;
        this.meta = meta;
        this.apiService = apiService;
        this.router = router;
        this.localize = localize;
    }
    CardListResolver.prototype.resolve = function (route, state) {
        var _this = this;
        var language = state.url.split('/')[1];
        var slugCategoria = route.params.categoriaScheda;
        if (!slugCategoria) {
            slugCategoria = state.url.split('/')[2];
        }
        console.log('CardListResolver -> ', language, ', ', slugCategoria, 'Query params', route.queryParams);
        var forUser = !slugCategoria.endsWith('-all');
        if (forUser) {
            this.meta.setTag('robots', 'noindex');
        }
        slugCategoria = slugCategoria.replace('-all', '');
        var jsonIn = new SearchSchede();
        jsonIn.language = language;
        if (route.queryParams && route.queryParams.pag) {
            jsonIn.numRecordIniziale = (route.queryParams.pag - 1) * environment.schedePerPagina + 1;
        }
        return this.storage.getMappone(language).pipe(map(function (mappone) {
            var categoria = mappone.categorie.find(function (c) { return c.seo && c.seo.slug === slugCategoria; });
            if (!categoria) {
                _this.router.navigate(['/' + language + '/404']);
            }
            _this.meta.setTitle(categoria.seo.title);
            if (categoria.seo.description) {
                _this.meta.setTag('description', categoria.seo.description);
            }
            if (categoria.seo.keywords) {
                _this.meta.setTag('keywords', categoria.seo.keywords);
            }
            jsonIn.categorie = [categoria.id];
            return { mappone: mappone, categoria: categoria };
        }), /*
        switchMap(({mappone, categoria}) => {
          return this.apiService.getSottocategorie({language, idCategoria: categoria.idCategoria}).pipe(
            map(sottocategorie => ({
              categoria,
              filtri: {
                macrozone: mappone.macrozone,
                zone: mappone.zone,
                bollini: mappone.mood,
                sottocategorie,
                filtri: mappone.filtri,
              }})
            )
          );
        }),*/ switchMap(function (_a) {
            var categoria = _a.categoria, mappone = _a.mappone /*, filtri*/;
            return _this.apiService.schedaSearchSchede(jsonIn).pipe(map(function (schedeResponse) { return ({ categoria: categoria, filtri: mappone.filtri, schedeResponse: schedeResponse, jsonIn: jsonIn, forUser: forUser }); }));
        }));
    };
    return CardListResolver;
}());
export { CardListResolver };
